/*undefined*/
"use strict";

var $protobuf = require("protobufjs/minimal");

// Common aliases
var $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
var $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

$root.UnscheduledModelMakeDropdownFilter = (function() {

    /**
     * Namespace UnscheduledModelMakeDropdownFilter.
     * @exports UnscheduledModelMakeDropdownFilter
     * @namespace
     */
    var UnscheduledModelMakeDropdownFilter = {};

    UnscheduledModelMakeDropdownFilter.UnscheduledModelMakeDropdownFilterModel = (function() {

        /**
         * Properties of an UnscheduledModelMakeDropdownFilterModel.
         * @memberof UnscheduledModelMakeDropdownFilter
         * @interface IUnscheduledModelMakeDropdownFilterModel
         * @property {string|null} [make] UnscheduledModelMakeDropdownFilterModel make
         * @property {number|null} [pageIndex] UnscheduledModelMakeDropdownFilterModel pageIndex
         * @property {number|null} [pageSize] UnscheduledModelMakeDropdownFilterModel pageSize
         */

        /**
         * Constructs a new UnscheduledModelMakeDropdownFilterModel.
         * @memberof UnscheduledModelMakeDropdownFilter
         * @classdesc Represents an UnscheduledModelMakeDropdownFilterModel.
         * @implements IUnscheduledModelMakeDropdownFilterModel
         * @constructor
         * @param {UnscheduledModelMakeDropdownFilter.IUnscheduledModelMakeDropdownFilterModel=} [p] Properties to set
         */
        function UnscheduledModelMakeDropdownFilterModel(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * UnscheduledModelMakeDropdownFilterModel make.
         * @member {string|null|undefined} make
         * @memberof UnscheduledModelMakeDropdownFilter.UnscheduledModelMakeDropdownFilterModel
         * @instance
         */
        UnscheduledModelMakeDropdownFilterModel.prototype.make = null;

        /**
         * UnscheduledModelMakeDropdownFilterModel pageIndex.
         * @member {number|null|undefined} pageIndex
         * @memberof UnscheduledModelMakeDropdownFilter.UnscheduledModelMakeDropdownFilterModel
         * @instance
         */
        UnscheduledModelMakeDropdownFilterModel.prototype.pageIndex = null;

        /**
         * UnscheduledModelMakeDropdownFilterModel pageSize.
         * @member {number|null|undefined} pageSize
         * @memberof UnscheduledModelMakeDropdownFilter.UnscheduledModelMakeDropdownFilterModel
         * @instance
         */
        UnscheduledModelMakeDropdownFilterModel.prototype.pageSize = null;

        // OneOf field names bound to virtual getters and setters
        var $oneOfFields;

        /**
         * UnscheduledModelMakeDropdownFilterModel _make.
         * @member {"make"|undefined} _make
         * @memberof UnscheduledModelMakeDropdownFilter.UnscheduledModelMakeDropdownFilterModel
         * @instance
         */
        Object.defineProperty(UnscheduledModelMakeDropdownFilterModel.prototype, "_make", {
            get: $util.oneOfGetter($oneOfFields = ["make"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * UnscheduledModelMakeDropdownFilterModel _pageIndex.
         * @member {"pageIndex"|undefined} _pageIndex
         * @memberof UnscheduledModelMakeDropdownFilter.UnscheduledModelMakeDropdownFilterModel
         * @instance
         */
        Object.defineProperty(UnscheduledModelMakeDropdownFilterModel.prototype, "_pageIndex", {
            get: $util.oneOfGetter($oneOfFields = ["pageIndex"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * UnscheduledModelMakeDropdownFilterModel _pageSize.
         * @member {"pageSize"|undefined} _pageSize
         * @memberof UnscheduledModelMakeDropdownFilter.UnscheduledModelMakeDropdownFilterModel
         * @instance
         */
        Object.defineProperty(UnscheduledModelMakeDropdownFilterModel.prototype, "_pageSize", {
            get: $util.oneOfGetter($oneOfFields = ["pageSize"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Encodes the specified UnscheduledModelMakeDropdownFilterModel message. Does not implicitly {@link UnscheduledModelMakeDropdownFilter.UnscheduledModelMakeDropdownFilterModel.verify|verify} messages.
         * @function encode
         * @memberof UnscheduledModelMakeDropdownFilter.UnscheduledModelMakeDropdownFilterModel
         * @static
         * @param {UnscheduledModelMakeDropdownFilter.IUnscheduledModelMakeDropdownFilterModel} m UnscheduledModelMakeDropdownFilterModel message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UnscheduledModelMakeDropdownFilterModel.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.make != null && Object.hasOwnProperty.call(m, "make"))
                w.uint32(10).string(m.make);
            if (m.pageIndex != null && Object.hasOwnProperty.call(m, "pageIndex"))
                w.uint32(16).int32(m.pageIndex);
            if (m.pageSize != null && Object.hasOwnProperty.call(m, "pageSize"))
                w.uint32(24).int32(m.pageSize);
            return w;
        };

        /**
         * Encodes the specified UnscheduledModelMakeDropdownFilterModel message, length delimited. Does not implicitly {@link UnscheduledModelMakeDropdownFilter.UnscheduledModelMakeDropdownFilterModel.verify|verify} messages.
         * @function encodeDelimited
         * @memberof UnscheduledModelMakeDropdownFilter.UnscheduledModelMakeDropdownFilterModel
         * @static
         * @param {UnscheduledModelMakeDropdownFilter.IUnscheduledModelMakeDropdownFilterModel} message UnscheduledModelMakeDropdownFilterModel message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UnscheduledModelMakeDropdownFilterModel.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an UnscheduledModelMakeDropdownFilterModel message from the specified reader or buffer.
         * @function decode
         * @memberof UnscheduledModelMakeDropdownFilter.UnscheduledModelMakeDropdownFilterModel
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {UnscheduledModelMakeDropdownFilter.UnscheduledModelMakeDropdownFilterModel} UnscheduledModelMakeDropdownFilterModel
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UnscheduledModelMakeDropdownFilterModel.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.UnscheduledModelMakeDropdownFilter.UnscheduledModelMakeDropdownFilterModel();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.make = r.string();
                    break;
                case 2:
                    m.pageIndex = r.int32();
                    break;
                case 3:
                    m.pageSize = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        /**
         * Decodes an UnscheduledModelMakeDropdownFilterModel message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof UnscheduledModelMakeDropdownFilter.UnscheduledModelMakeDropdownFilterModel
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {UnscheduledModelMakeDropdownFilter.UnscheduledModelMakeDropdownFilterModel} UnscheduledModelMakeDropdownFilterModel
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UnscheduledModelMakeDropdownFilterModel.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        return UnscheduledModelMakeDropdownFilterModel;
    })();

    return UnscheduledModelMakeDropdownFilter;
})();

module.exports = $root;
